import { useEffect } from 'react';
import { useHistory } from 'react-router-dom';
import { LocationListener } from 'history';

export const useHistoryChange = (callback: LocationListener) => {
  const history = useHistory();

  useEffect(() => history.listen(callback), [callback, history]);
};
